import { useEffect } from "react";
import { BehaviorSubject } from "rxjs";

export const DEFAULT_SHOW = false;
export const subjectShowProgress = new BehaviorSubject(DEFAULT_SHOW);

export default function useShowProgress(hide) {
  useEffect(() => {
    subjectShowProgress.next(hide);

    return () => subjectShowProgress.next(DEFAULT_SHOW);
  }, [hide]);
}
